const UNIFIED_STATIC_OVERRIDE_USERS = [
    'myriam.bordeleau@broadsign.com',
    'taki.belainine@broadsign.com',
    'swapnil.deshpande@broadsign.com',
    'sanket.raskar@broadsign.com',
];

const canEditUnifiedStatic = (username = '') =>
    UNIFIED_STATIC_OVERRIDE_USERS.includes((username || '').toLowerCase());

export { UNIFIED_STATIC_OVERRIDE_USERS, canEditUnifiedStatic };
